export default `#define V vec2(.7,-.7)
    #define G(p)dot(p,V)
    float i=0.,g=0.,e=1.;
    float t = 0.34; 
    for(int j=0;j++<8;){
      p=abs(rotate3D(0.34,vec3(1.0,-3.0,5.0))*p*2.)-1.,
      p.xz-=(G(p.xz)-sqrt(G(p.xz)*G(p.xz)+.05))*V;
    }
    return length(p.xz)/3e2;
  }`